module.exports = __webpack_public_path__ + "static/23-Kaon-3d26f95b41744bf293abfdf4b26a8d86.png";